var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isNested ? _c(_vm.loadField(_vm.field.field), {
    ref: _vm.field.key,
    tag: "component",
    attrs: {
      "disabled-field": _vm.disabledField,
      "opts": _vm.fieldOptions,
      "custom-errors": _vm.field.field === 'json' ? _vm.jsonErrors : []
    },
    on: {
      "input": _vm.handleInput
    }
  }) : _vm.isArray ? _c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.field.name[_vm.$i18n.locale]) + " ")]), _c('v-flex', [_vm._l(_vm.answersList, function (answers, rowId) {
    return _c('v-row', {
      key: rowId,
      staticClass: "mb-0",
      class: {
        'mb-8': _vm.answersList.length - 1 !== rowId
      }
    }, [_c('v-col', [_c('v-row', {
      staticClass: "align-center",
      staticStyle: {
        "border-bottom": "2px solid transparent"
      }
    }, _vm._l(_vm.field.children, function (childField, i) {
      return _c('v-col', {
        key: i,
        attrs: {
          "cols": _vm.getColumnSize(_vm.field.children.length)
        }
      }, [_c('NestedField', {
        ref: childField.key,
        refInFor: true,
        attrs: {
          "values": answers || {},
          "field": childField,
          "validation-error": _vm.validationError
        },
        on: {
          "input": function input($event) {
            return _vm.updateNestedValue(rowId, childField.key, $event);
          }
        }
      })], 1);
    }), 1)], 1)], 1);
  }), _c('div', {
    staticClass: "d-flex justify-space-between"
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.addAnswer();
      }
    }
  }, [_c('v-icon', [_vm._v(" mdi-plus-circle-outline ")])], 1), _vm.answersList.length > 1 ? _c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.removeAnswer();
      }
    }
  }, [_c('v-icon', [_vm._v(" mdi-bucket-outline ")])], 1) : _vm._e()], 1)], 2)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }